import { Link } from "react-router-dom";

export function AccessibilityStatement() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-16">
      <div className="max-w-4xl mx-auto space-y-8">
        <h1 className="text-3xl md:text-4xl font-heading font-bold text-text-title">
          Dichiarazione di Accessibilità
        </h1>

        <div className="prose prose-lg text-text-body max-w-none">
          <p>
            <strong>Puglia Life S.r.l.</strong> si impegna a rendere il proprio sito web accessibile, conformemente al D.lgs 10 agosto 2018, n. 106 che ha recepito la direttiva UE 2016/2102 del Parlamento europeo e del Consiglio.
          </p>
          <p>
            La presente dichiarazione di accessibilità si applica al sito web: <strong>https://puglialifesrl.it</strong>
          </p>

          <h2 className="text-2xl font-bold text-text-title mt-8 mb-4">Stato di conformità</h2>
          <p>
            Questo sito web è <strong>parzialmente conforme</strong> ai requisiti previsti dall'appendice A della norma UNI CEI EN 301549 in quanto alcune funzionalità o contenuti potrebbero non soddisfare pienamente i criteri WCAG 2.1 livello AA.
          </p>

          <h2 className="text-2xl font-bold text-text-title mt-8 mb-4">Contenuti non accessibili</h2>
          <p>
            I contenuti di seguito elencati non sono accessibili per i seguenti motivi:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Inosservanza della legge 4/2004:</strong> Alcuni documenti PDF potrebbero non essere completamente accessibili tramite screen reader. Stiamo lavorando per convertire le informazioni essenziali in formato HTML o rendere i PDF accessibili.
            </li>
            <li>
              <strong>Contenuti di terze parti:</strong> Alcuni componenti esterni (es. mappe, widget video) potrebbero non soddisfare tutti i criteri di accessibilità.
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-text-title mt-8 mb-4">Redazione della dichiarazione di accessibilità</h2>
          <p>
            La presente dichiarazione è stata redatta il <strong>20/02/2026</strong>.
          </p>
          <p>
            La valutazione è stata effettuata mediante un'analisi tecnica e verifiche soggettive (autovalutazione) basate sui criteri WCAG 2.1 livello AA.
          </p>

          <h2 className="text-2xl font-bold text-text-title mt-8 mb-4">Feedback e recapiti</h2>
          <p>
            Per inviare segnalazioni su casi di mancata conformità, richiedere informazioni o ottenere versioni alternative di documenti non accessibili, è possibile contattarci ai seguenti recapiti:
          </p>
          <ul className="list-none pl-0 space-y-2 mt-4">
            <li><strong>Email:</strong> <a href="mailto:info@puglialifesrl.it" className="text-brand-primary hover:underline">info@puglialifesrl.it</a></li>
            <li><strong>Telefono:</strong> <a href="tel:+390801234567" className="text-brand-primary hover:underline">+39 080 123 4567</a></li>
            <li><strong>Indirizzo:</strong> Via Esempio 123, Bari (BA)</li>
          </ul>

          <h2 className="text-2xl font-bold text-text-title mt-8 mb-4">Modalità di invio delle segnalazioni</h2>
          <p>
            Nella segnalazione si prega di indicare:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>L'URL della pagina in cui si è riscontrato il problema.</li>
            <li>Una descrizione del problema.</li>
            <li>Il dispositivo e il browser utilizzati.</li>
            <li>Eventuali tecnologie assistive utilizzate (es. JAWS, NVDA, VoiceOver).</li>
          </ul>

          <h2 className="text-2xl font-bold text-text-title mt-8 mb-4">Meccanismo di feedback</h2>
          <p>
            Puglia Life S.r.l. garantisce una risposta alle segnalazioni entro 30 giorni dalla ricezione.
          </p>
        </div>
      </div>
    </div>
  );
}
